import { createContext, useContext } from 'react';
import { IStoryContent } from '@opengov/stories-shared/types';

type EditorModalContextValue = {
  openClearContent(storyContent: IStoryContent): void;
  openDeleteContent(storyContent: IStoryContent): void;
  openResetContent(storyContent: IStoryContent): void;
  openAddBackground(storyContent: IStoryContent): void;
  openAddImage(storyContent: IStoryContent): void;
  openAddVideo(storyContent: IStoryContent): void;
  openAddEmbed(storyContent: IStoryContent): void;
  openAddContent(): void;
};

const EditorModalContext = createContext<EditorModalContextValue | undefined>(undefined);

// Used when no EditorModalProvider (e.g. read-only StoryPreview).
const NOOP_EDITOR_MODAL: EditorModalContextValue = {
  openClearContent(_storyContent: IStoryContent): void { },
  openDeleteContent(_storyContent: IStoryContent): void { },
  openResetContent(_storyContent: IStoryContent): void { },
  openAddBackground(_storyContent: IStoryContent): void { },
  openAddImage(_storyContent: IStoryContent): void { },
  openAddVideo(_storyContent: IStoryContent): void { },
  openAddEmbed(_storyContent: IStoryContent): void { },
  openAddContent(): void { },
};

export function useEditorModal(): EditorModalContextValue {
  const ctx = useContext(EditorModalContext);
  return ctx ?? NOOP_EDITOR_MODAL;
}

export const EditorModalProvider = EditorModalContext.Provider;
